
import { Annoucement } from '../../types';
import './AnnouncementCard.css';

function AnnouncementCard(annoucement: Annoucement) {
    return (
        <div className="announcement">
            <div className="info">
                <h3>{annoucement.name}</h3>
                <p>Due: {annoucement.date}</p>

                <div className="description">
                    <p>{annoucement.description}</p>
                </div>
            </div>
        </div>
    );
}

export default AnnouncementCard;